import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import config from './modules/config'
import category from './modules/category'
import place from './modules/place'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    config,
    category,
    place
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js